/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IUpdateEdiInboundAs2ConnectionConfigMutationVariables = Types.Exact<{
  input: Types.IUpdateInboundAs2ConnectionConfigInput
}>

export type IUpdateEdiInboundAs2ConnectionConfigMutation = { __typename?: 'Mutation' } & {
  updateEdiInboundAs2ConnectionConfig?: Types.Maybe<
    { __typename?: 'UpdateInboundAs2ConnectionConfigPayload' } & Pick<
      Types.IUpdateInboundAs2ConnectionConfigPayload,
      'clientMutationId'
    > & {
        ediInboundConnectionConfig?: Types.Maybe<
          { __typename?: 'InboundConnectionConfig' } & Pick<
            Types.IInboundConnectionConfig,
            | 'id'
            | 'partnerApplicationId'
            | 'partnerApplicationType'
            | 'createdAt'
            | 'connectionType'
            | 'disabled'
            | 'filenameGlob'
            | 'send997s'
          > & {
              partnerApplication?: Types.Maybe<
                | ({ __typename: 'CarrierApplication' } & Pick<Types.ICarrierApplication, 'id'> & {
                      carrierName: Types.ICarrierApplication['name']
                    })
                | ({ __typename: 'ShipperApplication' } & Pick<Types.IShipperApplication, 'id'> & {
                      shipperName: Types.IShipperApplication['name']
                    })
              >
              as2ConnectionConfig?: Types.Maybe<
                { __typename?: 'As2ConnectionConfig' } & Pick<
                  Types.IAs2ConnectionConfig,
                  'id' | 'identifier'
                >
              >
            }
        >
        errors: Array<{ __typename?: 'Error' } & Pick<Types.IError, 'key' | 'message'>>
      }
  >
}

export const UpdateEdiInboundAs2ConnectionConfigDocument = gql`
  mutation UpdateEdiInboundAs2ConnectionConfig($input: UpdateInboundAs2ConnectionConfigInput!) {
    updateEdiInboundAs2ConnectionConfig(input: $input) {
      clientMutationId
      ediInboundConnectionConfig {
        id
        partnerApplication {
          __typename
          ... on ShipperApplication {
            id
            shipperName: name
          }
          ... on CarrierApplication {
            id
            carrierName: name
          }
        }
        partnerApplicationId
        partnerApplicationType
        createdAt
        as2ConnectionConfig {
          id
          identifier
        }
        connectionType
        disabled
        filenameGlob
        send997s
      }
      errors {
        key
        message
      }
    }
  }
`
export type IUpdateEdiInboundAs2ConnectionConfigMutationFn = Apollo.MutationFunction<
  IUpdateEdiInboundAs2ConnectionConfigMutation,
  IUpdateEdiInboundAs2ConnectionConfigMutationVariables
>

/**
 * __useUpdateEdiInboundAs2ConnectionConfigMutation__
 *
 * To run a mutation, you first call `useUpdateEdiInboundAs2ConnectionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEdiInboundAs2ConnectionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEdiInboundAs2ConnectionConfigMutation, { data, loading, error }] = useUpdateEdiInboundAs2ConnectionConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEdiInboundAs2ConnectionConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateEdiInboundAs2ConnectionConfigMutation,
    IUpdateEdiInboundAs2ConnectionConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateEdiInboundAs2ConnectionConfigMutation,
    IUpdateEdiInboundAs2ConnectionConfigMutationVariables
  >(UpdateEdiInboundAs2ConnectionConfigDocument, options)
}
export type UpdateEdiInboundAs2ConnectionConfigMutationHookResult = ReturnType<
  typeof useUpdateEdiInboundAs2ConnectionConfigMutation
>
export type UpdateEdiInboundAs2ConnectionConfigMutationResult = Apollo.MutationResult<
  IUpdateEdiInboundAs2ConnectionConfigMutation
>
export type UpdateEdiInboundAs2ConnectionConfigMutationOptions = Apollo.BaseMutationOptions<
  IUpdateEdiInboundAs2ConnectionConfigMutation,
  IUpdateEdiInboundAs2ConnectionConfigMutationVariables
>
